<template>
    <v-snackbar v-model="openMode" :timeout="4000" :color="getSnackbarColor" class="custom-snackbar" bottom right
        elevation="6">
        <div class="snackbar-content">
            <v-icon left :color="getIconColor" class="snackbar-icon" >
                {{ getSnackbarIcon }}
            </v-icon>
            <span class="snackbar-text">{{ snacbarText }}</span>
        </div>

        <template v-slot:action="{ attrs }">
            <v-btn text :color="getButtonColor" v-bind="attrs" @click="openMode = false" class="close-button">
                <v-icon small >mdi-close</v-icon>
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
export default {
    props: {
        snacbarText: String,
        snackbarColorBt: {
            type: String,
            default: "primary"
        },
        value: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        openMode: {
            get() {
                return this.value;
            },
            set(v) {
                return this.$emit('input', v);
            }
        },
        getSnackbarColor() {
            // Set background color based on the type
            if (this.snackbarColorBt === "green") return "#4caf50";
            if (this.snackbarColorBt === "red") return "#f44336";
            if (this.snackbarColorBt === "orange") return "#ff9800";
            if (this.snackbarColorBt === "blue") return "#2196f3";
            return this.snackbarColorBt; // Use the provided color
        },
        getSnackbarIcon() {
            // Set icon based on the type
            if (this.snackbarColorBt === "green") return "mdi-check-circle";
            if (this.snackbarColorBt === "red") return "mdi-alert-circle";
            if (this.snackbarColorBt === "orange") return "mdi-alert";
            if (this.snackbarColorBt === "blue") return "mdi-information";
            return "mdi-bell"; // Default icon
        },
        getIconColor() {
            return "white";
        },
        getButtonColor() {
            return "white";
        }
    }
}
</script>

<style scoped>
.custom-snackbar {
    border-radius: 8px;
}

.snackbar-content {
    display: flex;
    align-items: center;
}

.snackbar-icon {
    margin-left: 12px;
}

.snackbar-text {
    font-size: 14px;
    font-weight: 500;
}

.close-button {
    margin-left: 8px;
    min-width: 36px !important;
    height: 36px !important;
}

/* Override Vuetify styles */
:deep(.v-snack__wrapper) {
    min-width: 320px !important;
    max-width: 500px !important;
}

:deep(.v-snack__content) {
    padding: 12px 16px !important;
}
</style>